import Box, { BoxProps } from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { CheckedMenuItem, MenuItemWithIcon, MoreHorizMenu } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

const SORT_BY_LATEST_REPLY = "CommentSortByLatestReply";
const SORT_BY_DATE = "CommentSortByDate";

const SHOW_RESOLVED_COMMENT = "ShowResolvedComment";
const HIDE_RESOLVED_COMMENT = "HideResolvedComment";

const SHOW_ALL_RELATED_COMMENTS = "ShowAllRelatedComments";
const SHOW_COMMENTS_ON_PRIMARY_TYPE_ONLY = "ShowCommentsOnPrimaryTypeOnly";

const FilterOptionMenu: FunctionComponent<BoxProps> = observer((props) => {
	const { commentsStore } = useStore();
	const {
		hideResolved,
		sortByLatestReply,
		showRelated,
		commentPaths,
		primaryType,
	} = commentsStore;
	const hasRelated = commentPaths.length > 0;
	const locale = useLocale();

	return (
		<Box {...props}>
			<MoreHorizMenu>
				<CheckedMenuItem
					checked={sortByLatestReply}
					onClick={() => commentsStore.applySortByLatestReply(true)}
					text={locale.resource(SORT_BY_LATEST_REPLY)}
				/>
				<CheckedMenuItem
					checked={!sortByLatestReply}
					onClick={() => commentsStore.applySortByLatestReply(false)}
					text={locale.resource(SORT_BY_DATE)}
				/>
				<Divider />
				<MenuItemWithIcon
					onClick={() => commentsStore.toggleHideResolved()}
					text={locale.resource(hideResolved ? SHOW_RESOLVED_COMMENT : HIDE_RESOLVED_COMMENT)}
				>
					{hideResolved ?
						<VisibilityIcon color="action" style={{ fontSize: 16 }} />
						:
						<VisibilityOffIcon color="action" style={{ fontSize: 16 }} />
					}
				</MenuItemWithIcon>
				{hasRelated &&	// Menu does not access Fragment as child, so test separately for each item
					<Divider />
				}
				{hasRelated && (
					<CheckedMenuItem
						checked={showRelated}
						onClick={() => commentsStore.applyShowRelatedItem(true)}
						text={locale.resource(SHOW_ALL_RELATED_COMMENTS)}
					/>
				)}
				{hasRelated && (
					<CheckedMenuItem
						checked={!showRelated}
						onClick={() => commentsStore.applyShowRelatedItem(false)}
						text={locale.resource(SHOW_COMMENTS_ON_PRIMARY_TYPE_ONLY, [locale.type(primaryType)])}
					/>
				)}
			</MoreHorizMenu>
		</Box>
	);
});

export default FilterOptionMenu;